import _defineProperty from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import CometaSearchComponent from '../CometaSearch/CometaSearchComponent';
import Tooltip from '../../../../Tooltip/Tooltip';
import industryCodeUtils from '../../../utils/industryCodesUtils';
import { countries } from '../../../utils/constants';
import { required } from '../../../utils/validationUtils';
import { Util } from '../../../../../services';
export var tooltipIndustryCodes = {
  sic: React.createElement('span', null, 'SIC Code (Standard Industrial Classification)', React.createElement('br', null), React.createElement('br', null), 'Please type the first 3 letters of the name of the industry to which your company belongs. Several options will be displayed, select the one that best identifies your type of business.', React.createElement('br', null), React.createElement('br', null), 'Examples (con for construction, man for manufacturing, etc.)'),
  naics: React.createElement('span', null, 'NAICS (North American Industry Classification System)', React.createElement('br', null), React.createElement('br', null), 'Please type the name of the first 3 letters of the economic activity to which your company belongs. Several options will be displayed, select the one that best identifies your type of business.', React.createElement('br', null), React.createElement('br', null), 'Example (Farm, Gas, Construction)'),
  cnae: {
    BRA: 'Classificação Nacional de Atividades Econômicas- The National Classification of Economic Activities (CNAE) is the official industry code system of the Brazilian government.',
    CIALOnlineInvestigation: 'Classificação Nacional de Atividades Econômicas- The National Classification of Economic Activities (CNAE) is the official industry code system of the Brazilian government.',
    MEX: 'SCIAN is the Mexican version of the North American Industry Classification System (NAICS) used by businesses and governments to classify and measure economic activity in the United States, Canada, and Mexico.',
    PER: 'The Uniform International Industrial Classification (CIIU) list is the official industry code system administered by the Instituto Nacional de Estadística e Informática of the Peruvian government.',
    GTM: 'The Uniform International Industrial Classification (CIIU) list is the official industry code system administered by the Ministerio de Trabajo y Previsión Social of the Guatemalan government.',
    CHL: 'The Uniform International Industrial Classification (CIIU) list is the official industry code system promulgated by the Instituto Nacional de Estadísticas of the Chilean government.',
    ARG: 'The National Classifier of Economic Activities (CLAE) is the official industry code system administered by the Instituto Nacional de Estadística y Censos of the Argentine government.'
  }
};

var industryLabel = function industryLabel(value, country) {
  var isRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return React.createElement(Tooltip, {
    text: country ? tooltipIndustryCodes[value][country] : tooltipIndustryCodes[value],
    position: 'right',
    id: value
  }, React.createElement('span', null, value.toUpperCase(), ' primary industry'), React.createElement('span', {
    notranslate: 'true'
  }, isRequired ? '*' : '', " \u24D8"));
};

var CometaIndustryCodesComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(CometaIndustryCodesComponent, _Component);

  function CometaIndustryCodesComponent(props) {
    var _this$state;

    var _this;

    _classCallCheck(this, CometaIndustryCodesComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CometaIndustryCodesComponent).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_assertThisInitialized(_this)));

    var listName = props.listName;
    _this.state = (_this$state = {}, _defineProperty(_this$state, "".concat(listName, "Primary"), null), _defineProperty(_this$state, "".concat(listName, "Secondary"), null), _defineProperty(_this$state, "naicsPrimary", null), _defineProperty(_this$state, "naicsSecondary", null), _defineProperty(_this$state, "sicPrimary", null), _defineProperty(_this$state, "sicSecondary", null), _this$state);
    return _this;
  }

  _createClass(CometaIndustryCodesComponent, [{
    key: "dispatchFieldChange",
    value: function dispatchFieldChange(fieldName, value, persistOldValues) {
      var previousValues = this.state[fieldName];

      if (persistOldValues && !Array.isArray(previousValues)) {
        previousValues = [previousValues];
      }

      this.setState(this.stateReducer({
        key: fieldName,
        value: value
      }), this.handleIndustryCodeChange(fieldName));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          listName = _this$props.listName,
          country = _this$props.country,
          meta = _this$props.meta,
          language = _this$props.language;
      return React.createElement('div', null, (countries.BRA === country || countries.ONLINE_INVESTIGATION === country) && React.createElement(Fragment, null, React.createElement(CometaSearchComponent, {
        listName: listName,
        country: country,
        language: language,
        handleChange: this.createFieldChangeHandler("".concat(listName, "Primary")),
        input: this.createInputObject({
          listName: "".concat(listName, "Primary")
        }),
        meta: meta,
        label: industryLabel('cnae', country)
      }), React.createElement(CometaSearchComponent, {
        isMulti: true,
        listName: listName,
        country: country,
        language: language,
        handleChange: this.createFieldChangeHandler("".concat(listName, "Secondary")),
        input: this.createInputObject({
          listName: "".concat(listName, "Secondary")
        }),
        meta: {},
        label: listName.toUpperCase() + " secondary industry"
      })), React.createElement(CometaSearchComponent, {
        listName: 'sic',
        country: country,
        language: language,
        handleChange: this.createFieldChangeHandler('sicPrimary'),
        input: this.createInputObject({
          listName: 'sicPrimary'
        }),
        meta: meta,
        label: industryLabel('sic', undefined, true),
        validate: [required]
      }), React.createElement(CometaSearchComponent, {
        isMulti: true,
        listName: 'sic',
        country: country,
        language: language,
        handleChange: this.createFieldChangeHandler('sicSecondary'),
        input: this.createInputObject({
          listName: 'sicSecondary'
        }),
        meta: {},
        label: 'SIC secondary industry'
      }), React.createElement(CometaSearchComponent, {
        listName: 'naics',
        country: country,
        language: language,
        handleChange: this.createFieldChangeHandler('naicsPrimary'),
        input: this.createInputObject({
          listName: 'naicsPrimary'
        }),
        meta: {},
        label: industryLabel('naics')
      }), React.createElement(CometaSearchComponent, {
        isMulti: true,
        listName: 'naics',
        country: country,
        language: language,
        handleChange: this.createFieldChangeHandler('naicsSecondary'),
        input: this.createInputObject({
          listName: 'naicsSecondary'
        }),
        meta: {},
        label: 'NAICS secondary industry'
      }));
    }
  }]);

  return CometaIndustryCodesComponent;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.componentDidMount = function () {
    var value = _this2.props.input.value;
    value && _this2.setState(value);
  };

  this.stateReducer = function (action) {
    return function (state) {
      if (!action.key) {
        return state;
      }

      return _extends({}, state, _defineProperty({}, action.key, action.value));
    };
  };

  this.handleIndustryCodeChange = debounce(function (fieldName) {
    var _this2$props = _this2.props,
        handleChange = _this2$props.handleChange,
        input = _this2$props.input,
        country = _this2$props.country;

    var industryCodeData = _extends({}, _this2.state);

    input.onChange(industryCodeData);
    handleChange(industryCodeData);

    if (fieldName.indexOf('cnae') >= 0) {
      industryCodeUtils.updateDependentFields(fieldName, industryCodeData[fieldName], country, _this2.dispatchChangeForDependentFields);
    }
  }, 200);

  this.dispatchChangeForDependentFields = function (fieldName, sicAndNaics) {
    var isPrimary = fieldName.indexOf('Primary') > 0;
    var sicCodes = industryCodeUtils.convertSicForStore(sicAndNaics);
    var naicsCodes = industryCodeUtils.convertNaicsForStore(sicAndNaics);
    sicCodes = sicCodes && sicCodes.map(function (sicCode) {
      return sicCode.value;
    }) || [];
    naicsCodes = naicsCodes && naicsCodes.map(function (naicsCode) {
      return naicsCode.value;
    }) || [];

    if (isPrimary) {
      _this2.dispatchFieldChange('sicPrimary', sicCodes[0], false);

      _this2.dispatchFieldChange('naicsPrimary', naicsCodes[0], false);
    } else {
      _this2.dispatchFieldChange('sicSecondary', sicCodes, true);

      _this2.dispatchFieldChange('naicsSecondary', naicsCodes, true);
    }
  };

  this.createFieldChangeHandler = function (fieldName) {
    return function (option) {
      _this2.dispatchFieldChange(fieldName, option);
    };
  };

  this.createInputObject = function (_ref) {
    var listName = _ref.listName,
        placeholder = _ref.placeholder;
    var input = _this2.props.input;
    return {
      placeholder: placeholder,
      value: input.value && input.value[listName],
      onChange: Util.noop,
      onFocus: input.onFocus,
      onBlur: input.onBlur
    };
  };
};

;
CometaIndustryCodesComponent.propTypes = {
  listName: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  input: PropTypes.shape({
    value: PropTypes.object,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  })
};
export default CometaIndustryCodesComponent;